<template>
    <span class="formui_query_param_item" >

                     <!--<hr v-if="itemIndex==groupNamesMoreLimit">-->
<!--{{fieldItem.name}}-->
        <!--<span v-if="fieldItem.valueType=='HIDDEN'" style="width: 0;height: 0;overflow: hidden;position: absolute;">-->
             <!--<span v-if="fieldItem.valueType=='HIDDEN'" >-->
                        <!--============={{fieldItem.name}}-->
        <!--style="width: 0;height: 0;overflow: hidden;position: fixed;"-->
                   <el-form-item :label="fieldItem.title" :prop="fieldItem.name" v-if="fieldItem.valueType=='HIDDEN'"
                                 style="width: 0;height: 0;overflow: hidden;position: fixed;left:0;" >
                          <el-input style="width: 210px" :placeholder="'请输入'+fieldItem.title"
                                    v-model="ruleForm[fieldItem.name]"
                                    @change="submitForm()"
                          ></el-input>
                       <!--<el-input :label="fieldItem.title"  v-model="ruleForm[fieldItem.name]" @change="submitForm()"></el-input>-->
                   </el-form-item>

                    <!--</span>-->

                <el-form-item :label="fieldItem.title" :prop="fieldItem.name" v-else>

                    <!--{{fieldItem.valueType}}-->

                    <span v-if="fieldItem.foreignStyleClass!='FormUiStyle'">
                        <!--{{fieldItem.foreignStyleClass}}-->
                        <!--{{fieldItem.name}}_{{ruleForm[fieldItem.name]}}-->
                        <component v-bind:is="'formUiStyleSelect'"
                                   ref="formUiStyleSelect"
                                   v-bind:fieldName="fieldItem.name"
                                   v-bind:beanName="fieldItem.foreignStyleClass"
                                   v-bind:fieldValue="ruleForm[fieldItem.name]"
                                   v-bind:defaultLabel="'全部'"
                                   v-bind:isQuery="true"
                                   @setFieldValue="setFieldValue"
                        ></component>

                    </span>
                    <span v-else-if="fieldItem.foreignServiceClass!='FormUiForeignService'&&fieldItem.valueType=='INTEGER'">
                        <!--{{fieldItem.foreignStyleClass}}-->
                        <!--{{fieldItem.name}}-->
                        <!--{{ruleForm[fieldItem.name]}}-->

                        <component v-bind:is="'formUiForeignSelect'"
                                   ref="formUiForeignSelect"
                                   v-bind:fieldName="fieldItem.name"
                                   v-bind:beanName="fieldItem.foreignServiceClass"
                                   v-bind:fieldValue="ruleForm[fieldItem.name]"
                                   v-bind:defaultLabel="'全部'"
                                   v-bind:fieldItem="fieldItem"
                                   v-bind:formData="ruleForm"
                                   @setFieldValue="setFieldValue"
                        ></component>

                    </span>

                     <span v-else-if="fieldItem.foreignServiceClass!='FormUiForeignService'&&fieldItem.valueType=='STRING'">
                        <!--{{fieldItem.foreignStyleClass}}-->
                         <!--{{fieldItem.name}}-->
                         <!--{{ruleForm[fieldItem.name]}}-->
                        <component v-bind:is="'formUiForeignStr'"
                                   ref="formUiForeignStr"
                                   v-bind:fieldName="fieldItem.name"
                                   v-bind:beanName="fieldItem.foreignServiceClass"
                                   v-bind:fieldValue="ruleForm[fieldItem.name]"
                                   @setFieldValue="setFieldValue"
                        ></component>

                    </span>
                    <!--formUiForeignSelect-->
                    <span v-else-if="fieldItem.valueType=='INTEGER'">
                        <el-input  style="width: 162px" v-model="ruleForm[fieldItem.name]" controls-position="right" :min="-9999999" :max="9999999" @change="submitForm()" :controls="false"></el-input>
                         <!--<el-input-number v-model="ruleForm[fieldItem.name]" controls-position="right" :min="-99999" :max="99999" @change="submitForm()" :controls="false"></el-input-number>-->
                    </span>
                    <span v-else-if="fieldItem.valueType=='MONEY'">

                         <el-input-number  style="width: 162px" v-model="ruleFormMoney[fieldItem.name]" controls-position="right" :min="-9999999" :max="9999999" @change="submitForm()"  :controls="false"></el-input-number>
                    </span>
                    <span v-else-if="fieldItem.valueType=='STRING'">
                        <el-input style="width: 162px" :placeholder="'请输入'+fieldItem.title"
                                  v-model="ruleForm[fieldItem.name]"
                                  @change="submitForm()"
                        ></el-input>
                    </span>
                    <span v-else-if="fieldItem.valueType=='TEXT'">
                        <el-input style="width: 162px" :placeholder="'请输入'+fieldItem.title"
                                  v-model="ruleForm[fieldItem.name]"
                                  type="textarea"
                                  @change="submitForm()"
                        ></el-input>
                    </span>

                    <!--<span v-else-if="fieldItem.valueType=='TEXT'">-->
                        <!--<el-input style="width: 220px" :placeholder="'请输入'+fieldItem.title"-->
                                  <!--v-model="ruleForm[fieldItem.name]"-->
                                  <!--@change="submitForm()"-->
                                  <!--type="textarea"-->
                        <!--&gt;</el-input>-->
                    <!--</span>-->
                    <span v-else-if="fieldItem.valueType=='DATETIME'">

                        <el-date-picker

                                v-model="ruleFormTime[fieldItem.name]"
                                :ref="ruleFormTime[fieldItem.name]"
                                type="datetime"
                                @change="setFieldValue(fieldItem.name,ruleFormTime[fieldItem.name])"
                                placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd  HH:mm:ss" />
                    </span>
                    <span v-else-if="fieldItem.valueType=='DATE_BEGIN'">

                        <el-date-picker
                                width="162"
                                v-model="ruleFormTime[fieldItem.name]"
                                :ref="ruleFormTime[fieldItem.name]"
                                type="date"
                                @change="setFieldValue(fieldItem.name,ruleFormTime[fieldItem.name])"
                                placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
                    </span>
                    <span v-else-if="fieldItem.valueType=='DATE_END'">
                        <el-date-picker
                                v-model="ruleFormTime[fieldItem.name]"
                                :ref="ruleFormTime[fieldItem.name]"
                                type="date"
                                @change="setFieldValue(fieldItem.name,ruleFormTime[fieldItem.name])"
                                placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
                    </span>

                    <span v-else-if="fieldItem.valueType=='MONTH_BEGIN'">
                        <el-date-picker
                                v-model="ruleFormTime[fieldItem.name]"
                                :ref="ruleFormTime[fieldItem.name]"
                                type="month"
                                @change="setFieldValue(fieldItem.name,ruleFormTime[fieldItem.name])"
                                placeholder="选择日期" value-format="yyyy-MM" format="yyyy-MM" />
                    </span>
                    <span v-else-if="fieldItem.valueType=='MONTH_END'">
                        <el-date-picker
                                v-model="ruleFormTime[fieldItem.name]"
                                :ref="ruleFormTime[fieldItem.name]"
                                type="month"
                                @change="setFieldValue(fieldItem.name,ruleFormTime[fieldItem.name])"
                                placeholder="选择日期" value-format="yyyy-MM" format="yyyy-MM" />
                    </span>

                    <span v-else>
                                {{fieldItem.valueType}}
                    </span>

                </el-form-item>
    </span>
</template>

<script>
//  import util from '../../../../util/util'
  import mathUtil from './service/lib/math.js'
//  import router from '../../../../router'
  import formuiService from './service/formui/FormuiService.js'
  import formUiStyleSelect from './widget/FormUiStyleSelect.vue'
  import formUiForeignSelect from './widget/FormUiForeignSelect.vue'
  import FormUiForeignStr from './widget/FormUiForeignStr.vue'
//  import ImgUploadOss from '../../base/ImgUploadOss.vue'
  import moment from 'moment'
export default {
  name: 'UIForm_form',
    props: ['beanName','removeFileds','ruleFormSrc','fieldItem'],
    components:{formUiStyleSelect,formUiForeignSelect,FormUiForeignStr},
    data () {
    return {
        loadSuccess:false,
//        removeFileds:[],
        rules:{},
        ruleForm:{},
        ruleFormMoney:{},
        ruleFormTime:{},
      formuiFields: [], // 渠道类型
      isFieldGroup: false,//是否是带分组的
        groupNames:{'':''},
        groupNamesShow:{'':100},
        groupNamesMoreLimit:1

    }
  },

  methods: {
      showAll(groupNameKey){
          let that=this
//        alert(groupNameKey)
//          this.groupNamesShow[groupNameKey]=10
          this.$set(that.groupNamesShow,'时间',10)

      },
      uploadImg (newimagePath, newimageUrl,name) {
          this.ruleForm[name] = newimagePath
          this.ruleForm[name+'Url'] = newimageUrl
//          console.log('imagePath=' + imagePath)
//          console.log('imageUrl=' + imageUrl)
      },
    // 提交
    submitForm () {
//          alert(11111)
//        let formName='ruleForm'
//      console.log(this.queryParams)
      let that = this

//        alert(that.formuiFields.length)
//        console.log(that.formuiFields)
//        for(let i=0;i< that.formuiFields.length;i++){
          let fieldItem=this.fieldItem
//          alert(fieldItem.name)
            if(fieldItem.valueType=='MONEY'){
//                alert(mathUtil.methods.mul)
                if(that.ruleFormMoney[fieldItem.name]==null){
                    this.$delete(that.ruleForm,fieldItem.name)
//                    that.ruleForm[fieldItem.name]=''
                }else{
                    that.ruleForm[fieldItem.name]=mathUtil.mul(that.ruleFormMoney[fieldItem.name],100)
                }

            }else if(fieldItem.valueType=='DATETIME'||fieldItem.valueType=='DATE_BEGIN'||fieldItem.valueType=='DATE_END'){
//                alert(1)
//                alert(that.ruleFormTime[fieldItem.name])
                that.ruleForm[fieldItem.name]=that.ruleFormTime[fieldItem.name]
            }


//        }
//        alert(fieldItem.name+'='+that.ruleForm[fieldItem.name])
        this.$emit('setFieldValue', fieldItem.name,that.ruleForm[fieldItem.name])


    },
      setFieldValue:function (key,value) {
//        alert(key+"__"+value)
//          this.$set(this.ruleForm,key,value)
          this.$emit('setFieldValue', key,value)
//        this.submitForm()
      },
      formatTime(date){
          return moment(date).format("YYYY-MM-DD HH:mm:ss");

      },
      setRules(){
          let that=this


          let fields=this.formuiFields
          for(var i=0;i<fields.length;i++){
              // alert(fields[i])
              if(fields[i].required==true){
//                  alert(fields[i].name)
                  that.rules[fields[i].name]=[
                      { required: true, message: '请输入'+fields[i].title, trigger: 'blur' }
                  ]
              }

          }

//          return rules
      }
  },
    created(){
      let that=this
//        let queryKeys=Object.keys(that.$route.query);
//        for(var name of queryKeys){
//            alert(name)
            let name=this.fieldItem.name
//        alert(this.fieldItem.name)

            if(that.$route.query[name]||that.$route.query[name]===''||that.$route.query[name]===0){
//                alert(name+'=='+that.$route.query[name])
                if (Date.parse(that.$route.query[name]).toString() != "NaN") {

                    this.$set(that.ruleForm,name,that.$route.query[name]+"")
                    this.$set(that.ruleFormTime,name,that.$route.query[name]+"")

//                    this.$set(that.ruleForm,name,"2021-12-12 12:12:12")
                }else if (this.$route.query[name].toString().indexOf(',')!=-1) {
//                    this.queryParams[name]=this.$route.query[name]
                    this.$set(that.ruleForm,name,that.$route.query[name])

                }else if (parseFloat(that.$route.query[name]).toString() != "NaN"&& that.$route.query[name].indexOf('.')!=-1) {

                    this.$set(that.ruleForm,name,parseFloat(that.$route.query[name]))
                }else{

                    this.$set(that.ruleForm,name,that.$route.query[name])
                }
            }

            let fieldItem=this.fieldItem


//            alert(this.fieldItem.name+'='+that.ruleForm[fieldItem.name])
        this.$emit('setFieldValue', fieldItem.name,that.ruleForm[fieldItem.name])
//            alert(that.ruleForm.ids)
//        }

//        that.ruleFormTime.purchaseCreateTimeBeginTime=''

    },
  mounted () {
//    console.log('-----------mounted-------------')
//    let isEmpty = util.isStringEmpty(this.$route.query.channelId)
      let that=this
      if(!this.ruleFormSrc){
//        alert('未设置ruleFormSrc！')
      }else{
//          that.ruleForm=this.ruleFormSrc
      }




  },

  updated () {
//    console.log('-----------updated-------------')
  },

  destory () {

  }
}
</script>

<style>
    /*.param-table{display: inline;}*/
    /*.param-table tr{display: inline;}*/
    /*.param-table td{display: inline;}*/
    /*.param-table td.param-td{ background: #eee;padding: 0px 10px; line-height: 30px;position: relative;padding-right: 60px;}*/
    /*.param-table th{width: 80px;}*/
    /*.param-table td .showAll{ position: absolute; right: 10px; top:10px; color: #aaa;}*/
    /*.param-table td .closeAll{ position: absolute; right: 10px; top:10px; color: #02A7F0;}*/

    /*.param-table tr.item-more td{background: none;}*/
    /*.el-form-item {*/
        /*!*margin: 5px;*!*/
    /*}*/
    /*.el-form-item label{display: inline-block;height: 44.5px;}*/
    /*.el-form-item::before label{display: inline-block;height: 44.5px;}*/
    table .formui_query_param_item  .el-form-item__label{display: inline-block;padding-top: 2px;}
    table .formui_query_param_item .el-form-item{margin: 16px 20px 16px 0px;}
</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiQueryParamItem.vue